import { DONATION_INFO_TEXT } from './donation-info';
import { EventsService } from '@services/events/events.service';
import { Component, inject } from '@angular/core';
import { VariablesService } from '@services/variables/variables.service';
import { UtilService } from '@services/util/util.service';
import { VwoService } from '@services/vwo/vwo.service';
import { ICampaigner } from '@models/fundraiser.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AsyncPipe, NgIf } from '@angular/common';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';
import { CurrencyIconPipe } from '@pipes/currency-icon/currency-icon.pipe';
import { UtilPipe } from '@pipes/util-pipe/util-pipe.pipe';
import { ButtonComponent } from '@common-components/button/button.component';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-donation-confirmation',
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    CustomTranslatePipe,
    CurrencyIconPipe,
    UtilPipe,
    ButtonComponent,
    CurrencyIconComponent,
    MatButtonModule
  ],
  templateUrl: './donation-confirmation.component.html',
  styleUrls: ['./donation-confirmation.component.scss']
})
export class DonationConfirmationComponent {

  readonly vars = inject(VariablesService);
  readonly util = inject(UtilService);
  readonly vwo = inject(VwoService);
  readonly dialog = inject(MatDialog);
  readonly dialogRef = inject(MatDialogRef<DonationConfirmationComponent>);
  data = inject(MAT_DIALOG_DATA);
  private events = inject(EventsService);
  private router = inject(Router);
  private actRoute = inject(ActivatedRoute);

  beneficiaryName = '';
  isNGO = false;
  isStorypage = false;
  miniStory = false;
  campaigner: ICampaigner;
  isMedical = false;

  cancelPayment = new Subject();

  info = DONATION_INFO_TEXT;

  ngOnInit() {
    this.getBeneficiaryName();
    if (this.router.url.match('stories')) {
      this.isStorypage = true;
    }
    if (this.actRoute.snapshot.queryParams.mini_story) {
      this.miniStory = true;
    }
  }

  getBeneficiaryName() {
    if (this.vars.fundraiser && this.vars.fundraiser.beneficiary) {
      this.beneficiaryName = this.vars.fundraiser?.beneficiary?.full_name || this.vars.basicInfo?.beneficiary_name;
    } else if (this.vars.fundraiser?.beneficiaryname) {
      this.beneficiaryName = this.vars.fundraiser?.beneficiaryname?.info_1;
    } else {
      this.beneficiaryName = this.vars.basicInfo?.beneficiary_name;
    }
    this.isNGO = this.vars.fundraiser?.parent_cause_id === 48;
    this.isMedical = this.vars.ALL_MEDICAL_CAUSES.includes(this.vars.fundraiser?.cause?.id) ? true : false;
  }

  handleCloseAndSendEvent(choice): void {
    const self = this;
    const choices = {
      cancel: () => {
        self.dialog.closeAll();
        this.cancelPayment.next(true);
        return 'cancel_popup';
      },
      closeBtn: () => {
        self.dialogRef.close();
        return 'close_btn_popup';
      },
      help: () => {
        self.dialogRef.close();
        return 'help_popup';
      }
    };

    const info1 = choices[choice]() || '';
    const payload = {
      eventName: 'donation_confirmation',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      event_type_id: this.vars.fundraiser.id,
      info_1: info1,
      info_2: ''
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

}
